module.exports = __webpack_public_path__ + "media/images/bg/patterns/mosaic-900d860236917147e431eccaa667ba58.svg";